import React, {Component} from "react";
import {connect} from "react-redux";
import AccessDeny from "../AccessDeny";
import Loading from "../Loading";
import {Link} from "react-router-dom";
import axios from "axios";

class BPPhaseCreate extends Component{

    constructor(props) {
        super(props);
        this.state = {
            item: {
                id: null,
                name: '',
                description:''
            },
        }
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
    }

    handleChangeName = (e) =>{
        const { item } = this.state;
        item.name = e.target.value;
        this.setState({item: item});
    }
    handleChangeDescription = (e) =>{
        const { item } = this.state;
        item.description = e.target.value;
        this.setState({item: item});
    }
    handleSubmit = () =>{
        const { item } = this.state;
        const contestId = this.props?.match?.params?.contestId;
        console.log('contest id:'+contestId)
        if(item?.name === ''){
            this.setState({errorMessage: 'Vui lòng nhập tên đợt'})
            return;
        }
        if(item?.description === ''){
            this.setState({errorMessage: 'Vui lòng nhập mô tả đợt'})
            return;
        }
        if(contestId === null){
            this.setState({errorMessage: 'Xảy ra lỗi, không xác định được Đợt!'})
            return;
        }
        const formData = new FormData();
        formData.append('contestId', contestId);
        formData.append('name', item?.name);
        formData.append('description', item?.description);
        this.setState({isLoading: true})
        if(item?.id === null){
            axios.post('/api/bankportal/contest/phase/save', formData)
                .then(response =>{
                    if(response.data === null){
                        this.setState({errorMessage: 'Xảy ra lỗi khi lưu thông tin!', successMessage:'', isLoading: false})
                    }
                    this.setState({item: response.data, errorMessage: '', successMessage:'Lưu thông tin thành công', isLoading: false})
                })
                .catch(error =>{
                    this.setState({errorMessage: error.message, successMessage: '', isLoading: false});
                })
        }else{
            const formData = new FormData();
            formData.append('id', item?.id);
            formData.append('contestId', item?.contestId);
            formData.append('name', item?.name);
            formData.append('description', item?.description);
            formData.append('status', item?.status);
            formData.append('bankCode', item?.bankCode);
            formData.append('createdBy', item?.createdBy);
            formData.append('updatedBy', item?.updatedBy);
            formData.append('createdDate', item?.createdDate);
            formData.append('updatedDate', item?.updatedDate);
            this.setState({isLoading: true})
            axios.post('/api/bankportal/contest/phase/update', formData)
                .then(response =>{
                    if(response.data === null){
                        this.setState({errorMessage: 'Xảy ra lỗi khi lưu thông tin!', successMessage:'', isLoading: false})
                    }
                    this.setState({item: response.data, errorMessage: '', successMessage:'Cập nhật thông tin thành công', isLoading: false})
                })
                .catch(error =>{
                    this.setState({errorMessage: error.message, successMessage: '', isLoading: false});
                })
        }
    }
    render() {
        if(!this.props.isRoleFWDContest) return <AccessDeny />

        const {item, isLoading,errorMessage, successMessage} = this.state;
        const { contestId } = this.props?.match?.params?.contestId;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'container'}>
                <div>
                    <div>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">
                            { !!item?.id && <span>CẬP NHẬT - ĐỢT</span> }
                            { !item?.id && <span>TẠO MỚI - ĐỢT</span> }
                        </h2>
                        <form>
                            <input type="hidden" name="id" value={item?.id} />
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Tên đợt :</label>
                                <div className="col-sm-9">
                                    <span><input type="text" id="name" className={'form-control'} value={item?.name} onChange={this.handleChangeName}/></span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="description">Mô tả :</label>
                                <div className="col-sm-9">
                                    <span><input type="text" id="description" className={'form-control'} value={item?.description} onChange={this.handleChangeDescription}/></span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/contest/'+this.props?.match?.params?.contestId+'/detail'} className="btn btn-success">Quay về</Link>
                                    <button type="button" onClick={this.handleSubmit} className="btn btn-primary ml-1">
                                        { !!item?.id && <span>Cập nhật</span> }
                                        { !item?.id && <span>Tạo mới</span> }
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );


    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO };
};

export default connect(mapStateToProps)(BPPhaseCreate);